module.exports = __webpack_public_path__ + "static/media/35.fc668af4.jpg";